module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph-epi"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_ix",
      "title": "ix"
    }
  }, [_vm._v("With that Christian brake out with a loud voice: Oh, I see him again! and he tells me, “When thou passest through the waters, I will be with thee, and through the rivers, they shall not overflow thee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-epi"
  }, [_vm._v("Then they both took courage, and the enemy was after that as still as a stone, until they were gone over. Christian therefore presently found ground to stand upon; and so it followed that the rest of the river was but shallow. Thus they got over.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source-epis"
  }, [_vm._v("—"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("JOHN BUNYAN")]), _vm._v(", "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Pilgrim’s Progress")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0